import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { GlobalsVariables } from '../global-Variables';

@Component({
  selector: 'app-dataprivacy',
  templateUrl: './dataprivacy.component.html',
  styleUrls: ['./dataprivacy.component.scss']
})
export class DataPrivacyComponent implements OnInit {

  constructor( public meta: Meta, public title: Title, private globalVari: GlobalsVariables ) {
    const site = 'dataprivacy';
    this.meta.updateTag({ name: 'description', content: globalVari.meta[site].description });
    this.title.setTitle('Chris Wehrmann - ' + globalVari.meta[site].title );
  }

  ngOnInit() {
  }

}
